import _core from "./core.js";
import _regexDom from "./regexDom.js";
import _state from "./state.js";
import _helpers from "./helpers.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearState = exports.renderSSR = exports.initSSR = void 0;
const core_js_1 = _core;
const regexDom_js_1 = _regexDom;
const state_js_1 = _state;
const helpers_js_1 = _helpers; // functions that should only be available on the server-side

const ssrTricks = {
  isWebComponent: tagNameOrComponent => {
    return typeof tagNameOrComponent === "string" && tagNameOrComponent.includes("-") && _nano.customElements.has(tagNameOrComponent);
  },
  renderWebComponent: (tagNameOrComponent, props, children, _render) => {
    const customElement = _nano.customElements.get(tagNameOrComponent);

    const component = _render({
      component: customElement,
      props: Object.assign(Object.assign({}, props), {
        children: children
      })
    }); // get the html tag and the innerText from string
    // match[1]: HTMLTag
    // match[2]: innerText


    const match = component.toString().match(/^<(?<tag>[a-z]+)>(.*)<\/\k<tag>>$/);

    if (match) {
      const element = document.createElement(match[1]);
      element.innerText = match[2]; // eslint-disable-next-line no-inner-declarations

      function replacer(match, p1, _offset, _string) {
        return match.replace(p1, "");
      } // remove events like onClick from DOM


      element.innerText = element.innerText.replace(/<\w+[^>]*(\s(on\w*)="[^"]*")/gm, replacer);
      return element;
    } else {
      return null;
    }
  }
};

const initGlobalVar = () => {
  const isSSR = (0, helpers_js_1.detectSSR)() === true ? true : undefined;
  const location = {
    pathname: "/"
  };
  const document = isSSR ? (0, regexDom_js_1.documentSSR)() : window.document;
  globalThis._nano = {
    isSSR,
    location,
    document,
    customElements: new Map(),
    ssrTricks
  };
};

initGlobalVar();

const initSSR = (pathname = "/") => {
  _nano.location = {
    pathname
  };
  globalThis.document = _nano.document = (0, core_js_1.isSSR)() ? (0, regexDom_js_1.documentSSR)() : window.document;
};

exports.initSSR = initSSR;

const renderSSR = (component, options = {}) => {
  const {
    pathname,
    clearState = true
  } = options;
  (0, exports.initSSR)(pathname);
  if (clearState) state_js_1._state.clear();
  return (0, core_js_1.render)(component, null, true).join("");
};

exports.renderSSR = renderSSR;

const clearState = () => {
  state_js_1._state.clear();
};

exports.clearState = clearState; //# sourceMappingURL=ssr.js.map

export default exports;